import axios from '@xpeng/union-login';
import type { AxiosRequestConfig } from 'axios';

const axiosInstance = axios({
  loginCodeList: [12150008, 12150005]
});

export type XDragonApiResponse<T> = {
  code: number;
  data: T;
  msg: string;
  record?: string;
};

export type XDragonApiResponsePromise<T> = Promise<XDragonApiResponse<T>>;
export function ajax<T = any>(config: AxiosRequestConfig): XDragonApiResponsePromise<T> {
  if (!config.method) {
    config.method = 'get';
  }
  const request = axiosInstance[config.method.toLowerCase()];
  if (!request) {
    throw new Error(`Unsupported request method: ${config.method}`);
  }
  return request.call(axiosInstance, config.url, config.data, { timeout: 30000 });
}
